const callFunctionOnce = (fun) => {
  let called = false
  let returnValue

  const oneTimeFun = () => {
    if (!called) {
      called = true
      returnValue = fun()
    }

    return returnValue
  }

  return oneTimeFun
}

export default callFunctionOnce



// WEBPACK FOOTER //
// ./utils/CallFunctionOnce.js